"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var tasks;
        (function (tasks) {
            var review;
            (function (review) {
                function init() {
                    addEvents();
                }
                review.init = init;
                function addEvents() {
                    $('td').on('click', 'a#viewMedia', function (event) {
                        event.preventDefault();
                        appn.dialog.viewMediaFromElement($(this));
                    });
                }
            })(review = tasks.review || (tasks.review = {}));
        })(tasks = views.tasks || (views.tasks = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
